// extracted by mini-css-extract-plugin
module.exports = {"text":"ActionsWhenEditing_text__1DSID","modalContainer":"ActionsWhenEditing_modalContainer__2KD9o"};